import React, { useMemo } from 'react';
import { translate } from '../../Services/translation';
import { clearFilter, clearFilters } from '../../Actions/FacetedSearch.action';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../Icon';

const FilterChips = () => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.productFiltering?.facetFilters);

  const hasAnyOptionSelected = useMemo(() => {
    if (filters && !!filters.length) {
      return filters.findIndex((f) => !!f.selectedOptions.length) != -1;
    }
    return false;
  }, [filters]);

  return hasAnyOptionSelected ? (
    <div className="filter-chips">
      <button
        className="filter-chips__clear-btn"
        onClick={() => dispatch(clearFilters())}
      >
        {translate('general.clear-filters')}
        <Icon name="Close" size={16} className="filter-chips__clear-btn-icon" />
      </button>
      {filters.flatMap((filterGroup) =>
        filterGroup.selectedOptions.map((selectedOption) => {
          const option = filterGroup.options.find(
            (opt) => opt.id === selectedOption
          );
          if (option) {
            return (
              <button
                key={`${filterGroup.id}-${option.id}`}
                className="filter-chip"
                onClick={() => dispatch(clearFilter(filterGroup.id, option.id))}
              >
                {filterGroup.label}: {option.label}
                <Icon
                  name="Close"
                  size={16}
                  className="filter-chips__clear-btn-icon"
                />
              </button>
            );
          }
          return null;
        })
      )}
    </div>
  ) : null;
};

export default FilterChips;
